import React from 'react'
import PropTypes from 'prop-types'
import {
    Container,
    Box
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {renderComponentsSwitch} from '../../../components/optimizely/utils/contentRenderer'
import {getImageColSpan} from './list-menu-helpers'

/**
 * Renders CMS illustration-only mega menu content (no category columns).
 * Images are placed in the 12-column grid with colSpan from IllustrationWidth.
 */
const CMSIllustrationOnlyContent = ({ item, baseStyle, onClose }) => {
    const illustrationBlocks = item?.CMSMegaMenuData?.MegaMenuIlustrationBlockList || []

    return (
        <Container {...baseStyle.popoverContainer}>
            <Box {...baseStyle.megaMenuGrid}>
                {illustrationBlocks.map((illustrationBlock, index) => {
                    const expandedBlock = illustrationBlock?.ContentLink?.Expanded || illustrationBlock?.Expanded
                    return (
                        <Box
                            key={`img-only-${index}`}
                            gridColumn={`span ${getImageColSpan(illustrationBlock)}`}
                        >
                            {renderComponentsSwitch(expandedBlock, {index, onClose})}
                        </Box>
                    )
                })}
            </Box>
        </Container>
    )
}

CMSIllustrationOnlyContent.propTypes = {
    item: PropTypes.object,
    baseStyle: PropTypes.object,
    onClose: PropTypes.func
}

export { CMSIllustrationOnlyContent }
